const minutesToMs = (min: number) => min * 60 * 1000;

export const QUERY_CONFIG = {
  HOME: {
    REFRESH_MIN: Number(process.env.REACT_APP_HOME_REFRESH_MIN || 5),
  },
  PROJECT: {
    REFRESH_MIN: Number(process.env.REACT_APP_PROJECT_REFRESH_MIN || 2),
  },
  PERSIST: {
    MAX_AGE_MIN: Number(process.env.REACT_APP_MAX_AGE || 10),
  },
};

export const QUERY_TIMES_MS = {
  HOME_REFRESH: minutesToMs(QUERY_CONFIG.HOME.REFRESH_MIN),
  PROJECT_REFRESH: minutesToMs(QUERY_CONFIG.PROJECT.REFRESH_MIN),
  MAX_AGE: minutesToMs(QUERY_CONFIG.PERSIST.MAX_AGE_MIN),
};
